const ACTIVE = 'active';
const INACTIVE = 'inactive';
const APPROVED = 'approved';
const REJECTED = 'rejected';
const CANCELED = 'canceled';
const PENDING = 'pending';

export default {
  ACTIVE,
  INACTIVE,
  APPROVED,
  REJECTED,
  CANCELED,
  PENDING
};
